// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4dfd4ac7","85":"7eabb8ed","604":"18dd19ba","746":"881097d3","977":"82a8f20b"}[chunkId] + ".chunk.js";
};